import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import LegalMarkdown from './LegalMarkdown';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fmt = (d) => (d ? new Date(`${d}T00:00:00`).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }) : '—');

// Public page shell for server-managed legal documents (privacy / terms).
export const LegalDocumentPage = ({ slug, testid }) => {
  const [doc, setDoc] = useState(null);
  const [error, setError] = useState('');

  const load = () => {
    setError('');
    axios.get(`${API}/legal/${slug}`).then((r) => setDoc(r.data)).catch(() => setError('Could not load this document. Please try again.'));
  };
  useEffect(load, [slug]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen bg-[#F2F4F7] text-slate-900" data-testid={testid}>
      <header className="bg-[#002FA7] text-white">
        <div className="max-w-3xl mx-auto px-6 py-10 sm:py-12">
          <img src="/icons/logo-wordmark.png" alt="CivilX TMS" className="h-10 w-auto object-contain mb-6" data-testid={`${slug}-logo`} />
          <h1 className="text-4xl sm:text-5xl font-bold tracking-tight" style={{ fontFamily: 'Work Sans, sans-serif' }} data-testid={`${slug}-title`}>
            {doc?.title || (slug === 'terms' ? 'Terms of Service' : 'Privacy Policy')}
          </h1>
          <p className="mt-3 text-base text-blue-100" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>CivilX TMS — Kollabsy Systems LLC</p>
          {doc && (
            <div className="mt-4 flex flex-wrap gap-x-6 gap-y-1 text-sm text-blue-100" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
              <span data-testid={`${slug}-effective-date`}>Effective Date: {fmt(doc.effective_date)}</span>
              <span data-testid={`${slug}-last-updated`}>Last Updated: {fmt(doc.last_updated)}</span>
              <span className="text-blue-200">Version {doc.version}</span>
            </div>
          )}
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-10 sm:py-12">
        <div className="bg-white border border-slate-200 rounded-lg shadow-sm p-6 sm:p-10">
          {!doc && !error && (
            <div className="flex items-center gap-2 text-slate-500 text-sm" data-testid={`${slug}-loading`}><Loader2 className="w-4 h-4 animate-spin" /> Loading…</div>
          )}
          {error && (
            <div className="text-sm text-red-700" data-testid={`${slug}-error`}>
              {error} <button type="button" onClick={load} className="underline font-semibold">Retry</button>
            </div>
          )}
          {doc && <LegalMarkdown body={doc.body} />}
        </div>
        <div className="mt-8 text-center text-sm font-semibold" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
          <a href="/login" data-testid={`${slug}-back-to-login`} className="text-[#002FA7] hover:text-[#00247D] hover:underline">← Back to CivilX TMS</a>
          <span className="mx-3 text-slate-300">·</span>
          {slug === 'terms'
            ? <a href="/privacy-policy" data-testid="terms-privacy-link" className="text-[#002FA7] hover:underline">Privacy Policy</a>
            : <a href="/terms" data-testid="privacy-terms-link" className="text-[#002FA7] hover:underline">Terms of Service</a>}
        </div>
      </main>
    </div>
  );
};

export default LegalDocumentPage;
